module.exports = __webpack_public_path__ + "img/Logo-gofiqr.b2781547.jpg";